import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/vorgangsarten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierType"
      returnRoute="/auswahlfelder/dossierTypes"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierTypesRoute = Route;
